/**
 * Label of the "Email sent" tile in the Dashboard's Dial Outcomes widget.
 * Renamed from "Email" to "SQL" (Sales Qualified Lead) per client request.
 * Kept as a single constant so the tile's displayed label and the check
 * that decides whether to show its CSV/Salesforce download actions can
 * never drift apart again.
 */
export const DIAL_OUTCOME_SQL_LABEL = 'SQL';
